import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const orderAdditionalCostLineItemPayStatusesAdapter = getAdapter({ idFieldName: 'value' });

const orderAdditionalCostLineItemPayStatusesSlice = createSlice({
    name: 'orderAdditionalCostLineItemPayStatuses',
    initialState: orderAdditionalCostLineItemPayStatusesAdapter.getInitialState(),
    reducers: {
        setOrderAdditionalCostLineItemPayStatuses: (state, { payload: { orderAdditionalCostLineItemPayStatuses } }) => {
            orderAdditionalCostLineItemPayStatusesAdapter.setAll(state, orderAdditionalCostLineItemPayStatuses);
        },
    },
});

const selectors = orderAdditionalCostLineItemPayStatusesAdapter.getSelectors(({ orderAdditionalCostLineItemPayStatuses }) => orderAdditionalCostLineItemPayStatuses);

export const getOrderAdditionalCostLineItemPayStatuses = (state) => selectors.selectAll(state);

export const {
    setOrderAdditionalCostLineItemPayStatuses,
} = orderAdditionalCostLineItemPayStatusesSlice.actions;

export default orderAdditionalCostLineItemPayStatusesSlice.reducer;
